import { MS_PER_S, type PzRacingDataRow } from '@pitbrain/shared'

const POINTS_PER_S = 10
const MS_PER_POINT = MS_PER_S / POINTS_PER_S

const pointIndexOf = (row: PzRacingDataRow): number =>
  Math.round(row.time * POINTS_PER_S)

const averageOf = (
  rows: PzRacingDataRow[],
  field: 'longitude' | 'latitude' | 'direction' | 'speed'
): number => rows.reduce((sum, row) => sum + row[field], 0) / rows.length

export function aggregatePzRacingRows(
  data: PzRacingDataRow[]
): PzRacingDataRow[] {
  const firstRow = data[0]
  if (!firstRow) return []
  const headerMs =
    new Date(firstRow.date).getTime() - Math.round(firstRow.time * MS_PER_S)

  const pointOf = (
    pointIndex: number,
    rows: PzRacingDataRow[]
  ): PzRacingDataRow => ({
    time: pointIndex / POINTS_PER_S,
    longitude: averageOf(rows, 'longitude'),
    latitude: averageOf(rows, 'latitude'),
    direction: averageOf(rows, 'direction'),
    speed: averageOf(rows, 'speed'),
    date: new Date(headerMs + pointIndex * MS_PER_POINT),
  })

  const points: PzRacingDataRow[] = []
  let pointIndex = pointIndexOf(firstRow)
  let rows: PzRacingDataRow[] = []
  for (const row of data) {
    const rowPointIndex = pointIndexOf(row)
    if (rowPointIndex !== pointIndex) {
      points.push(pointOf(pointIndex, rows))
      pointIndex = rowPointIndex
      rows = []
    }
    rows.push(row)
  }
  points.push(pointOf(pointIndex, rows))
  return points
}
